import { useNavigate } from 'react-router-dom'
import { notifications } from '@mantine/notifications'
import { useQuery } from '@tanstack/react-query'
import { chatDirectoryApi } from '@/api/chatDirectory'

/**
 * Abre (ou reabre) a DM da pessoa com o @Atendente e devolve o id da conversa — ou `null`, já
 * avisando, quando não deu. O bot do @Atendente tem nome reservado; os robôs também são `is_bot`.
 * Quem chama decide o que fazer com a conversa (hoje, navegar até ela). O painel do @DBA no editor
 * SQL NÃO usa o DM: abre a conversa do banco aberto (spec 2026-10-31-dba-conversa-do-banco).
 */
export function useAbrirDmDoAtendente() {
  const { data: people } = useQuery({
    queryKey: ['chat-directory-people'],
    queryFn: chatDirectoryApi.people,
    staleTime: 5 * 60 * 1000,
  })
  return async (): Promise<number | null> => {
    const bots = (people ?? []).filter((p) => p.is_bot)
    const atendente = bots.find((p) => p.name === 'Atendente') ?? bots[0]
    try {
      if (!atendente) throw new Error('sem_atendente')
      return await chatDirectoryApi.openDm(atendente.user_id)
    } catch {
      notifications.show({ color: 'red', title: 'Não foi possível abrir o @Atendente', message: 'Tente de novo em instantes.' })
      return null
    }
  }
}

/**
 * "Perguntar ao @Atendente": abre a DM com o texto no campo, SEM enviar — a pessoa revisa e
 * manda (spec 2026-10-20-kb-busca).
 */
export function usePerguntarAoAtendente() {
  const navigate = useNavigate()
  const abrir = useAbrirDmDoAtendente()
  return async (texto: string) => {
    const cid = await abrir()
    if (cid != null) navigate(`/chat/${cid}`, { state: { prefill: texto } })
  }
}
